import script from "./HomeSectionsFbochasComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeSectionsFbochasComponent.vue?vue&type=script&setup=true&lang=js"

import "./HomeSectionsFbochasComponent.vue?vue&type=style&index=0&id=f6ea38be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6ea38be"]])

export default __exports__